module.exports = __webpack_public_path__ + "static/628097352.65572aeb.jpg";